 
import { PublicClientApplication, Configuration, InteractionType } from '@azure/msal-browser';  
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';  
import { environment } from '../../environments/environment';  

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.msal.clientId,
    authority:  environment.msal.authority,
    redirectUri: environment.msal.redirectUri,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export async function getMsalInstance() {  
  const instance = new PublicClientApplication(msalConfig);  
  await instance.initialize();  
  return instance;  
}  

export const msalGuardConfig: MsalGuardConfiguration = {  
  interactionType: InteractionType.Redirect,  
  authRequest: {  
    scopes: environment.msal.scopes,  
  },  
};  

export const msalInterceptorConfig: MsalInterceptorConfiguration = {  
  interactionType: InteractionType.Redirect,  
  protectedResourceMap: new Map(environment.msal.protectedResourceMap),  
};  
